/* File location in theme: assets/pricing-table.js
   Powers the scroll-reveal animation in sections/pricing-table.liquid.

   Progressive enhancement only: every element this touches is already
   fully visible by default in pricing-table.css. If this script fails to
   load, or the visitor's browser doesn't support IntersectionObserver, the
   page still renders correctly — it just won't fade in on scroll. Nothing
   here is required for the page to work or to be readable/crawlable. */

(function () {
  'use strict';

  function initReveal(root) {
    var targets = root.querySelectorAll('.cwtcm-reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      // No IntersectionObserver support — just show everything immediately.
      targets.forEach(function (el) { el.classList.add('cwtcm-in-view'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('cwtcm-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) { observer.observe(el); });
  }

  function initAll() {
    document.querySelectorAll('.cwtcm-pricing').forEach(initReveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init if the section is added/edited live in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.cwtcm-pricing');
    if (root) initReveal(root);
  });
})();
